module.exports = __webpack_public_path__ + "img/banner_recomanda_2.86f268bd.png";